export const UPDATE_SALES_WIDGET = "UPDATE_SALES_WIDGET";